import ButtonVariants from "@core-components/button/ButtonVariants";
import EPublicRoutes from "@core-types/routes.enum";
import useAppLanguage from "@hooks/language/useAppLanguage";
import useAppTranslation from "@hooks/language/useAppTranslation";

const HelpCenterBackLink = () => {
  const { locationUrlBuilder } = useAppLanguage();
  const { t } = useAppTranslation("pages.helpCenter");

  return (
    <ButtonVariants.Back
      classNames={{
        root: "text-secret-purple-default hover:text-secret-purple-default",
      }}
      className="text-secret-purple-default"
      href={locationUrlBuilder(EPublicRoutes.FAQ)}
      label={t("common.backToHelpCenter")}
    />
  );
};

export default HelpCenterBackLink;
